import { DsmButton, DsmIcon, DsmModal } from "@dsm-dcs/design-system-react";
import { useIntl } from "../../../../_metronic/i18n/customUseIntl";
import { processAndStageStylesV2 } from "../../../../_metronic/layout/_core/MaterialThemeProvider";

export type RoiConfirmMode = "duplicate" | "edit";

type RoiConfirmDialogProps = {
  open: boolean;
  mode: RoiConfirmMode | null;
  onClose: () => void;
  onConfirm: () => void;
};

const DIALOG_TEXT_IDS: Record<
  RoiConfirmMode,
  { titleId: string; bodyId: string }
> = {
  duplicate: {
    titleId:
      "SUSTELL.CURRENT.BASELINE.MODEL.INTERVENTION.ROI.DUPLICATE.CONFIRM.TITLE",
    bodyId:
      "SUSTELL.CURRENT.BASELINE.MODEL.INTERVENTION.ROI.DUPLICATE.CONFIRM.BODY",
  },
  edit: {
    titleId:
      "SUSTELL.CURRENT.BASELINE.MODEL.INTERVENTION.ROI.EDIT.CONFIRM.TITLE",
    bodyId: "SUSTELL.CURRENT.BASELINE.MODEL.INTERVENTION.ROI.EDIT.CONFIRM.BODY",
  },
};

const RoiConfirmDialog = ({
  open,
  mode,
  onClose,
  onConfirm,
}: RoiConfirmDialogProps) => {
  const intl = useIntl();
  const classes = processAndStageStylesV2() as Record<string, string>;
  const texts = DIALOG_TEXT_IDS[mode ?? "edit"];

  return (
    <DsmModal
      open={open}
      onDsmClosed={(event) => {
        if (!event.detail) {
          onClose();
        }
      }}
    >
      <div
        id="icon"
        slot="content"
        style={{
          backgroundColor: "#FEF0C7",
          borderRadius: "24px",
          height: "48px",
          width: "48px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <DsmIcon
          name="alerts-feedback/alert-triangle"
          style={{ height: "24px", width: "24px", color: "#DC6803" }}
        />
      </div>
      <div id="title" slot="content" className={classes.deleteModalTitle}>
        {intl.formatMessage({ id: texts.titleId })}
      </div>
      <div id="body" slot="content">
        {intl.formatMessage({ id: texts.bodyId })}
      </div>
      <DsmButton variant="secondary" slot="actions" onClick={onClose}>
        {intl.formatMessage({ id: "GENERAL.CANCEL" })}
      </DsmButton>
      <DsmButton variant="primary" slot="actions" onClick={onConfirm}>
        {intl.formatMessage({ id: "GENERAL.CONTINUE" })}
      </DsmButton>
    </DsmModal>
  );
};

export default RoiConfirmDialog;
